import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import { isAdminUserLoggedIn } from 'lib/helper';
import React, { Suspense } from 'react';
import { CardTitle, Row, Col } from 'reactstrap';

import CADataGrid from './CADataGrid';
import CAInsights from './CAInsights';
import DashboardActions from './DashboardActions';
import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import {
  caListingDataAtom,
  filterValuesAtom,
  useOnFilterChangeResetAtoms,
} from './state';
import { getItemFromLocalStorage } from '../../helper';

const getInstallationUrl = () => {
  const baseUrl = getItemFromLocalStorage('approle') || 'guest';
  return `/${baseUrl}/qualys/cloud_agents/installation_instructions`;
};
const SelectedFilters: React.FC<{ filtersConfig }> = ({ filtersConfig }) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();
  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(caListingDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

let new_installation_link = <></>;
if (isAdminUserLoggedIn()) {
  const baseUrl = getItemFromLocalStorage('approle') || 'admin';
  const url = `/${baseUrl}/qualys/cloud_agents/new_installation_instructions`;
  new_installation_link = (
    <>
      &nbsp;
      <a
        href={url}
        id="CloudAgentsInstruction"
        target="_blank"
        rel="noreferrer"
        className="installation_instructions"
      >
        ( New Installation Instructions )
      </a>
    </>
  );
}

function CAListing() {
  const filtersConfig = useFilterConfig();
  return (
    <PageLayout
      id="ca_listing"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                Cloud Agents
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
              <a
                href={getInstallationUrl()}
                id="CloudAgentsInstruction"
                target="_blank"
                rel="noreferrer"
                className="installation_instructions"
              >
                Get Installation Instructions
              </a>
              {new_installation_link}
            </CardTitle>
          </Col>
        </Row>
      }
      subheading="List of Cloud Agents."
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="row mb-1">
            {/* Expanding Column */}
            <div className="col">
              <SelectedFilters filtersConfig={filtersConfig} />
            </div>
            {/* Fixed Column with Right-Aligned Content */}
            <div className="col-auto text-right align-baseline">
              <Suspense fallback={<>...</>}>
                <DashboardActions />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={<LoadingScreen />}>
            <CAInsights />
          </Suspense>
          <Suspense fallback={<LoadingScreen />}>
            <CADataGrid />
          </Suspense>
        </div>
      </Suspense>
    </PageLayout>
  );
}

const CAList: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen height={550} />}>
      <CAListing />
    </Suspense>
  );
};

export default CAList;
